export default {
  label: "Inicio",
};
